import React from "react";
import CustomModal from "../../components/molecules/Modal/customModal";

const ClearDomainJsonModal = ({ onCancelForm, modalTitle, selectedData }) => {
  return (
    <>
      <CustomModal
        handleModal={onCancelForm}
        cancelButtonRef={onCancelForm}
        className="max-w-4xl"
        modalType={true}
        title={modalTitle}
        hideButton={true}
      >
        <div className="space-y-2 mt-2">
          <div className="overflow-y-auto max-h-[300px] mt-2">
            <table className="table-auto w-full border-collapse">
              <thead className="bg-gray-50 sticky top-0 z-10">
                <tr>
                  <th className="border-b border-b-gray-300 px-2 py-2 text-center">
                    S.no
                  </th>
                  <th className="border-b border-b-gray-300 px-4 py-2">
                    Domain
                  </th>
                  <th className="border-b border-b-gray-300 px-4 py-2">
                    Frontend Status
                  </th>
                  <th className="border-b border-b-gray-300 px-4 py-2">
                    Backend Status
                  </th>
                </tr>
              </thead>
              <tbody>
                {selectedData?.map((data, index) => {
                  const frontendStatus = data.api_status;
                  const backendStatus = data.file_status;

                  const frontendBadgeColor =
                    frontendStatus === "Success"
                      ? "bg-green-100 text-green-800"
                      : frontendStatus === "Fail"
                      ? "bg-red-100 text-red-800"
                      : "bg-yellow-100 text-yellow-800";

                  const backendBadgeColor =
                    backendStatus === "Success"
                      ? "bg-green-100 text-green-800"
                      : backendStatus === "Fail"
                      ? "bg-red-100 text-red-800"
                      : "bg-yellow-100 text-yellow-800";

                  return (
                    <tr key={index} className="hover:bg-gray-50">
                      <td className="border-b border-b-gray-300 px-2 py-2 text-center">
                        {index + 1}
                      </td>
                      <td className="border-b border-b-gray-300 px-4 py-2">
                        {data.domain}
                      </td>
                      <td className="border-b border-b-gray-300 px-4 py-2">
                        <span
                          className={`text-xs font-medium px-2.5 py-0.5 rounded-sm ${frontendBadgeColor}`}
                        >
                          {frontendStatus}
                        </span>
                      </td>
                      <td className="border-b border-b-gray-300 px-4 py-2">
                        <span
                          className={`text-xs font-medium px-2.5 py-0.5 rounded-sm ${backendBadgeColor}`}
                        >
                          {backendStatus}
                        </span>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </CustomModal>
    </>
  );
};

export default ClearDomainJsonModal;
